import { Button, IconButton, FormHelperText, MenuList, Popper, Tooltip } from '@material-ui/core';
import { ClickAwayListener, Grow, MenuItem, MuiThemeProvider, Paper } from '@material-ui/core';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import cs from 'classnames';
import { DatePicker } from 'material-ui-pickers';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import * as actions from 'components/TrustCenter/store/actions';
import { getMobilityData } from 'components/TrustCenter/store/actions';
import Styles from './Mobility.module.css';
import TruckAgreements from './TruckAgreements/TruckAgreements';
import {
    PRIMARY_BUTTON_LIGHT_THEME,
    PRIMARY_BUTTON_GROUP_ICON_LIGHT_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import AddTruck from './AddTruck/AddTruck';
import { isNotEmptyList, isEmptyList } from 'components/Common/Utils/StringUtils';
import {
    convertToUTCDateTimeString,
    convertLocalDateString,
    isEqualDate
} from 'components/Common/Utils/DateUtils';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TDialog from 'components/UI/Dialog/TDialog';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import { isOtherGroupInEditMode } from '../TMS/Utils/TMSUtils';
import * as Constants from 'constants/Constants';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import AlertSnackBar from 'components/Common/AlertSnackbar/AlertSnackBar';

const options = ['ADD VEHICLE', 'ADD ALL VEHICLES'];
const ALL_TRUCK_OPTION = 1;

const Mobility = (props) => {
    const {
        agreements,
        agreementList,
        groupName,
        sidebarResource,
        mobilityData,
        newTruckAgreementList,
        newTruckAgreements,
        newAgreementGroup,
        existingAgreementGroup,
        editedAgreements,
        newShipperAgreement,
        isAgreementInEditMode,
        disableOtherOperation,
        hideLocalElement
    } = props;

    const [errorText, setErrorText] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const anchorRef = React.useRef(null);
    const [selectedIndex, setSelectedIndex] = React.useState(1);

    const getStartDate = () => {
        if (isNotEmptyList(agreementList) && agreementList[0].global_enabled_from !== undefined) {
            return new Date(convertLocalDateString(agreementList[0].global_enabled_from));
        } else {
            return new Date();
        }
    };

    const getEndDate = () => {
        if (isNotEmptyList(agreementList) && agreementList[0].global_expires_on !== undefined) {
            return new Date(convertLocalDateString(agreementList[0].global_expires_on));
        } else {
            let date = new Date();
            date.setMonth(date.getMonth() + 3);
            return date;
        }
    };

    const [endDate, setEndDate] = useState(getEndDate());
    const [startDate, setStartDate] = useState(getStartDate());
    let initialEndDate = getEndDate();
    let initialStartDate = getStartDate();
    const [isAllTrucksIncluded, setIsAllTrucksIncluded] = useState(false);

    useEffect(() => {
        if (isNotEmptyList(newTruckAgreementList)) {
            if (
                newTruckAgreementList.filter((agreement) => {
                    return agreement.truck_number === 'alltrucks';
                }).length > 0
            ) {
                setIsAllTrucksIncluded(true);
            } else {
                setIsAllTrucksIncluded(false);
            }
        } else {
            setIsAllTrucksIncluded(false);
        }
    }, [newTruckAgreementList]);

    const isNoTruckFound = mobilityData.length === 0;

    const [showDeleteAll, setShowDeleteAll] = useState(false);

    const [executeDelete, setExecuteDelete] = useState(false);

    const [openConfimation, setOpenConfimation] = useState(false);
    const [openSnack, setOpenSnack] = useState(false);

    const [showAddTruckModel, setShowAddTruckModel] = useState(false);

    const [changeStartDate, setChangeStartDate] = useState(false);

    const [changeEndDate, setChangeEndDate] = useState(false);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    const handleDateChange = (fieldName) => (date) => {
        if (fieldName === 'start-time') {
            if (!isEqualDate(startDate, date)) {
                setStartDate(date);
                if (date < endDate) {
                    setChangeStartDate(true);
                    setErrorText('');
                } else {
                    setErrorText('Expires-on date should be greater than Enabled-on date Timing');
                    setChangeStartDate(false);
                }
            }
        } else {
            if (!isEqualDate(endDate, date)) {
                setEndDate(date);
                if (startDate < date) {
                    setChangeEndDate(true);
                    setErrorText('');
                } else {
                    setErrorText('Expires-on date should be greater than Enabled-on date Timing');
                    setChangeEndDate(false);
                }
            }
        }
    };

    const handleErrorDateInAgreement = (fieldName) => (date) => {
        date = null;
        if (fieldName === 'start-time') {
            setStartDate(date);
            setTimeout(() => {
                endDate === getStartDate() ? setChangeStartDate(false) : setChangeStartDate(true);

                setErrorText('');
                setStartDate(getStartDate());
            }, 1);
        } else {
            setEndDate(date);
            setTimeout(() => {
                startDate === getEndDate() ? setChangeEndDate(false) : setChangeEndDate(true);
                setErrorText('');
                setEndDate(getEndDate());
            }, 1);
        }
    };

    const handleBlankDateInAgreement = (fieldName) => (event) => {
        if (event.target.value === '') {
            handleErrorDateInAgreement(fieldName)(event.target.value);
        }
    };

    const toggleAddTruckModal = (value) => {
        setErrorText('');
        if (startDate > endDate) {
            setErrorText('Expires-on date should be greater than Enabled-on date Timing');
        } else {
            if (value === 'ADD VEHICLE') {
                setShowAddTruckModel(true);
            } else {
                if (!isNoTruckFound) {
                    if (isEmptyList(newTruckAgreementList)) {
                        let truck_agreement = { ...newTruckAgreementList[0] };
                        if (newTruckAgreementList.length === 0) {
                            truck_agreement = {};
                        }
                        truck_agreement.agreement_type = Constants.AGREEMENT_TRUCK;
                        truck_agreement.group_name = Constants.GPS_ONLY;
                        truck_agreement.truck_id = 'alltrucks';
                        truck_agreement.truck_number = 'alltrucks';
                        truck_agreement.status = true;
                        truck_agreement.enabled_from = convertToUTCDateTimeString(startDate);
                        truck_agreement.global_enabled_from = convertToUTCDateTimeString(startDate);
                        truck_agreement.expires_on = convertToUTCDateTimeString(endDate);
                        truck_agreement.global_expires_on = convertToUTCDateTimeString(endDate);
                        let newTrucks = [];
                        newTrucks.push(truck_agreement);
                        newTruckAgreements(newTrucks);
                    }
                } else {
                    openSnackDialog(true);
                }
            }
        }
    };

    const closeAddTruckModel = () => {
        setShowAddTruckModel(false);
    };

    const handleMenuItemClick = (event, index) => {
        setSelectedIndex(index);
        setOpen(false);
    };

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = (event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }

        setOpen(false);
    };

    const disableButtonOption = (index) => {
        if (
            index === ALL_TRUCK_OPTION &&
            (isNotEmptyList(newTruckAgreementList) || isNotEmptyList(agreements[groupName]))
        ) {
            return true;
        }

        return selectedIndex === index;
    };

    const deleteSelectedTrucks = () => {
        setExecuteDelete(true);
        openConfirmationDialog(false);
        setShowDeleteAll(false);
    };

    const openConfirmationDialog = (closeDialog) => {
        setOpenConfimation(closeDialog);
    };

    const openSnackDialog = (closeSnack) => {
        setOpenSnack(closeSnack);
    };

    const disableFieldAndButtons = () => {
        return disablDeleteAllButtons() || isNotEmptyList(Object.keys(isAgreementInEditMode));
    };

    const disablDeleteAllButtons = () => {
        return (
            isOtherGroupInEditMode(
                newAgreementGroup,
                existingAgreementGroup,
                editedAgreements,
                newShipperAgreement,
                groupName,
                isAgreementInEditMode,
                newTruckAgreementList
            ) ||
            !isWriteAccessGranted ||
            disableOtherOperation
        );
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => openConfirmationDialog(false)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => deleteSelectedTrucks()}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );

    return (
        <div className="full-width">
            <div className="row">
                <div className="col-sm-6">
                    <div>
                        <DatePicker
                            id="datetime-local-start"
                            keyboard
                            variant="filled"
                            onError={handleErrorDateInAgreement('start-time')}
                            label="Enabled On"
                            fullWidth
                            margin="normal"
                            value={startDate}
                            name="start-time"
                            format={'MM/dd/yyyy'}
                            showTodayButton
                            keepCharPositions
                            onChange={handleDateChange('start-time')}
                            onBlur={handleBlankDateInAgreement('start-time')}
                            InputLabelProps={{
                                shrink: true
                            }}
                            disabled={disableFieldAndButtons()}
                            disableOpenOnEnter
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        />
                    </div>
                </div>
                <div className="col-sm-6">
                    <div>
                        <DatePicker
                            id="datetime-local-end"
                            keyboard
                            variant="filled"
                            fullWidth
                            margin="normal"
                            onError={handleErrorDateInAgreement('end-time')}
                            label="Expires On"
                            value={endDate}
                            name="end-time"
                            onBlur={handleBlankDateInAgreement('end-time')}
                            format={'MM/dd/yyyy'}
                            showTodayButton
                            onChange={handleDateChange('end-time')}
                            InputLabelProps={{
                                shrink: true
                            }}
                            disabled={disableFieldAndButtons()}
                            disableOpenOnEnter
                            mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
                        />
                    </div>
                </div>
            </div>
            <div>
                <FormHelperText style={{ color: 'red' }}>{errorText}</FormHelperText>
            </div>
            <br />
            <div>
                <Paper>
                    <div>
                        <div
                            className={cs(
                                'row full-width justify-content-between',
                                Styles.headerSpacing
                            )}
                        >
                            <div className={cs('col-sm-auto', Styles.vehiSize)}>Vehicles</div>
                            <div className="col-sm-auto text-right">
                                {!hideLocalElement && (
                                    <span ref={anchorRef} className={Styles.buttonPopper}>
                                        <MuiThemeProvider theme={PRIMARY_BUTTON_LIGHT_THEME}>
                                            <Button
                                                id={'addVehicle'}
                                                disabled={
                                                    isAllTrucksIncluded ||
                                                    (selectedIndex === ALL_TRUCK_OPTION &&
                                                        isNotEmptyList(agreements[groupName])) ||
                                                    disableFieldAndButtons()
                                                }
                                                onClick={() =>
                                                    toggleAddTruckModal(options[selectedIndex])
                                                }
                                                className={Styles.buttonGroupFirst}
                                            >
                                                {options[selectedIndex]}
                                            </Button>
                                        </MuiThemeProvider>
                                        <MuiThemeProvider
                                            theme={PRIMARY_BUTTON_GROUP_ICON_LIGHT_THEME}
                                        >
                                            <Button
                                                disabled={
                                                    isAllTrucksIncluded || disableFieldAndButtons()
                                                }
                                                className={cs(
                                                    Styles.buttonGroupLast,
                                                    Styles.matchTextButton
                                                )}
                                                aria-owns={open ? 'menu-list-grow' : undefined}
                                                aria-haspopup="true"
                                                onClick={handleToggle}
                                            >
                                                <ArrowDropDownIcon />
                                            </Button>
                                        </MuiThemeProvider>
                                    </span>
                                )}
                                <Popper
                                    open={open}
                                    anchorEl={anchorRef.current}
                                    transition
                                    disablePortal
                                    style={{
                                        zIndex: 100
                                    }}
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin:
                                                    placement === 'bottom'
                                                        ? 'center top'
                                                        : 'center bottom'
                                            }}
                                        >
                                            <Paper id="menu-list-grow">
                                                <ClickAwayListener onClickAway={handleClose}>
                                                    <MenuList>
                                                        {options.map((option, index) => (
                                                            <MenuItem
                                                                key={option}
                                                                disabled={disableButtonOption(
                                                                    index
                                                                )}
                                                                selected={index === selectedIndex}
                                                                onClick={(event) =>
                                                                    handleMenuItemClick(
                                                                        event,
                                                                        index
                                                                    )
                                                                }
                                                            >
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                                {showDeleteAll ? (
                                    <Tooltip title={'Delete vehicles'}>
                                        <IconButton
                                            disabled={disablDeleteAllButtons()}
                                            classes={{
                                                root: Styles.deleteAll,
                                                disabled: baseCSS.disabledIconButton
                                            }}
                                            onClick={() => openConfirmationDialog(true)}
                                            id={'deleteAll'}
                                        >
                                            <DeleteForeverIcon className="icon-button" />
                                        </IconButton>
                                    </Tooltip>
                                ) : null}
                            </div>
                        </div>
                        <div className={Styles.divTable}>
                            <TruckAgreements
                                hideLocalElement={hideLocalElement}
                                setShowDeleteAll={setShowDeleteAll}
                                setExecuteDelete={setExecuteDelete}
                                executeDelete={executeDelete}
                                startDate={startDate}
                                groupName={groupName}
                                endDate={endDate}
                                changeStartDate={changeStartDate}
                                changeEndDate={changeEndDate}
                                setChangeStartDate={setChangeStartDate}
                                setChangeEndDate={setChangeEndDate}
                                agreementList={isNotEmptyList(agreementList) ? agreementList : []}
                                setStartDate={setStartDate}
                                setEndDate={setEndDate}
                                initialStartDate={initialStartDate}
                                initialEndDate={initialEndDate}
                            />
                        </div>
                    </div>
                </Paper>
            </div>
            <AddTruck
                agreements={agreements}
                startDate={startDate}
                endDate={endDate}
                showAddTruckModel={showAddTruckModel}
                closeAddTruckModel={closeAddTruckModel}
            ></AddTruck>
            <TDialog
                id={'cancel_request'}
                open={openConfimation}
                handleClose={() => openConfirmationDialog(false)}
                dialogContentText={'Are you sure you want to delete these Trucks?'}
                dialogTitle={'Confirmation'}
                dialogActions={dialogAction}
            />
            <AlertSnackBar
                open={openSnack}
                resetSnackBar={() => openSnackDialog(false)}
                variant={'error'}
                message={'There are no Vehicles associated with this account'}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        agreements: state.agreement.agreements,
        mobilityData: state.agreement.mobilityData,
        newTruckAgreementList: state.agreement.newTruckAgreements,
        newAgreementGroup: state.agreement.newAgreementGroup,
        editedAgreements: state.agreement.editedAgreements,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        newShipperAgreement: state.agreement.newShipperAgreement,
        disableOtherOperation: state.agreement.disableOtherOperation,

        session: state.session.sessionValue,
        sidebarResource: state.header.sidebarResource
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMobilityData,
        newTruckAgreements: (truckAgreements) =>
            dispatch(actions.newTruckAgreements(truckAgreements)),
        updateNewAgreementGroup: (agreementGroupData) =>
            dispatch(actions.updateNewAgreementGroup(agreementGroupData)),
        updateEditedAgreements: (editedExistingAgreements) => {
            dispatch(actions.updateEditedAgreements(editedExistingAgreements));
        }
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Mobility));
